<template>
  <van-popup v-model="showUnit" position="bottom" class="unit-popup">
    <div class="top">
      <div class="btn" @click="showUnit = false">取消</div>
      <div class="btn" @click="confirm">确定</div>
    </div>
    <head-search
      v-model="params.search"
      placeholder="请输入 项目相关信息"
      @searchQuery="search"
      @searchCancel="onCancel"
    ></head-search>
    <no-data v-if="list.length == 0"></no-data>
    <div class="list-wrp" ref="listWrp">
      <van-radio-group v-model="radio" class="list" ref="list">
        <div class="list-item" v-for="(item, i) in list" :key="i">
          <van-radio :name="i">
            <div :class="radio==i ? 'main selected' : 'main'">
              <div class="name">{{ item.gcmc }}</div>
              <div class="info">
                <div class="label">项目代码</div>
                <div class="text">{{ item.gcbh }}</div>
              </div>
              <div class="info">
                <div class="label">项目详细地点</div>
                <div class="text">{{ item.gcxxdd }}</div>
              </div>
            </div>
          </van-radio>
        </div>
      </van-radio-group>
    </div>
  </van-popup>
</template>

<script>
import api from '@/utils/api/opinionPublish'
import HeadSearch from '@/components/HeadSearch.vue'
import NoData from '@/components/NoData.vue'
export default {
  components: { 
    HeadSearch,
    NoData,
  },
  props: {},
  data() {
    return {
      showUnit: false,
      searchValue: '',
      params: {
        page: 1,
        rows: 10,
        search: ""
      },
      list: [],
      fillMap: {},
      canscroll: true, 
      activeisload: true,
      radio: null,
    };
  },
  watch: {
    showUnit(val) {
      if(val) {
        this.$nextTick(() => {
          let listWrp = this.$refs['listWrp']
          let list = this.$refs['list'].$el
          // console.log(this.$refs, list, listWrp, listWrp.offsetHeight)
          listWrp.addEventListener("scroll", () => {
            if (this.canscroll) {
              let scroll_top = listWrp.scrollTop
              let list_height = list.offsetHeight
              let w_height = listWrp.offsetHeight
              
              // console.log(list_height, scroll_top + w_height, list_height - (scroll_top + w_height) < 100)
              if (list_height - (scroll_top + w_height) < 100) {
                this.canscroll = false; //锁定滚动触发条件
                if (this.activeisload) {
                  this.params.page++
                  this.getUnitList()
                } else {
                  console.log("已加载完所有已收藏的商品");
                }
              }
            }
          })
        })
      }
    }
  },
  computed: {},
  methods: {
    search(val) {
      console.log('搜索值', val)
      this.canscroll = true 
      this.activeisload = true
      this.params.page = 1
      this.params.search = val
      this.getUnitList()
    },
    // 取消搜索
    onCancel() {
      console.log('点击取消')
      this.canscroll = true 
      this.activeisload = true
      this.params.page = 1
      this.params.search = ''
      this.getUnitList()
    },
    confirm() {
      let data = this.list[this.radio]
      // console.log(data)
      // for(let key in data) {
      //   let upKey = key.toLocaleUpperCase()
      //   if(Object.prototype.hasOwnProperty.call(this.$parent.componentData, upKey)) {
      //     this.$parent.componentData[upKey] = data[key]
      //   }
      // }
      for(let key in this.fillMap) {
        this.$parent.componentData[key] = data[this.fillMap[key]]
      }
      // 处理XZQCode
      let options = this.$parent.$refs['XZQ'][0].options
      // console.log(this.$parent.$refs['XZQ'][0].options)
      options.forEach(item => {
        console.log(item.showValue, data['xzq'])
        if(item.showValue == data['xzq']) this.$parent.componentData['XZQCode'] = item.code
      })
      this.showUnit = false
    },
    getUnitList() {
      api.getHistoryProject(this.params).then(res => {
        let data = res.data
        this.fillMap = data.fillMap
        if(this.params.page==1) this.list = []
        if (data.rowsList.length) {
          this.list = this.list.concat(data.rowsList);
          if (data.rowsList.length < this.params.rows) {
            this.activeisload = false;
            console.log("已加载完");
          } else {
            this.canscroll = true;
          }
        }
      })
    },
  },
  created() {
    this.getUnitList()
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.unit-popup {
  .top {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #E5E5E5;
    .btn {
      padding: 8px 15px;
      color: #1D84FF;
      &:first-child {
        color: #999;
      }
    }
  }
  .list-wrp {
    padding-top: 57px;
    width: 100%;
    height: 60vh;
    overflow-y: auto;
    .list {
      height: auto;
      &-item {
        padding: 0 10px 10px;
        ::v-deep .van-radio__label {
          flex: 1;
        }
        .main {
          padding: 10px;
          border-radius: 5px;
          border: 1px solid #EFEFEF;
          &.selected {
            border: 1px solid #1D84FF;
            background-color: #F9FBFF;
          }
          .name {
            font-size: 16px;
            font-weight: bold;
          }
          .info {
            margin-top: 5px;
            font-size: 14px;
            color: #999;
            display: flex;
            align-items: flex-start;
            .label {
              width: 90px;
              text-align: right;
              padding-right: 10px;
            }
            .text {
              flex: 1;
              color: #333;
            }
          }
        }
      }
    }
  }
}
</style>